import image from '../assets/exit.png';
import UserService from '../services/user_service';

const CloseSession: React.FC = () => {

    return (
        <div className="container-presentation">
            <img src={image} alt="presentation" className="presentation-image" />
            <div className="description">
                <h1 className="title">DXPress</h1>
                <h2 className="subtitle">Estas por salirte de la app, recuerda contactar con el administrador en caso de problemas</h2>
                <button className="button is-danger" onClick={() => {
                    new UserService().exit();
                }}>
                    <label className="label">
                        Cerrar
                    </label>
                </button>
            </div>
        </div>
    );
}

export default CloseSession;